import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Stack, Button} from '@customink/pigment-react';
import {useDispatch} from 'react-redux';
import {resetInkMatches} from '~/actions/DesignActions';
import {metrics} from '~/vendor/metrics';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function RemovePantoneWarning({dismiss}) {
  const dispatch = useDispatch();

  const cancel = () => {
    metrics.pageViewTag('/ndx/upload/pantone/alert/cancel');
    dismiss();
  };

  const confirm = () => {
    metrics.setDimension('inkMatchCount', 0);
    metrics.pageViewTag('/ndx/upload/pantone/alert/success');
    dispatch(resetInkMatches());
    dismiss();
  };

  useEffect(() => {
    metrics.pageViewTag('/ndx/upload/pantone/alert');
  }, []);

  return (
    <Notification title="Remove Pantone color(s)?" dismiss={cancel}>
      <p className="ndx-cta1">
        This will remove all Pantone colors that have been entered.
      </p>
      <Stack className="notification-stack">
        <Button size="large" onClick={confirm}>
          Yes, Remove
        </Button>
        <Button
          size="large"
          sx={{marginTop: '0.5rem'}}
          variant="link"
          onClick={cancel}>
          Cancel
        </Button>
      </Stack>
    </Notification>
  );
}

RemovePantoneWarning.displayName = 'RemovePantoneWarning';

const propTypes = {
  dismiss: PropTypes.func
};

RemovePantoneWarning.propTypes = propTypes;
